
import { defineComponent } from 'vue';
import Shishiki from "@/enums/Shishiki";

export default defineComponent({
  name: 'ShishikiComponent',
  props: {
    codes: {type: String, required: true},
    historyFlg: {type: Boolean, default: false},
    colors: {type: Array as () => string[], required: false},
  },
  created() {
    this.init()
  },
  data(){
    return {
      codesArray: [] as string[],
      names: [] as string[],
      svgScale: 0.35,
      textColor: this.historyFlg ? 'gray' : 'black'
    }
  },
  methods: {
    init(){
      this.codesArray = []
      this.names = []
      if(this.codes){
        const ca = this.codes.trim().split('') as string[]
        for(const c of ca){
          if(c){
            this.codesArray.push(c as string)
            this.names.push(Shishiki.getName(c) as string)
          }
        }
      }

    }

  },
  watch:{
    codes(){
      this.init()
    }
  }
});
